<template>
  <div class="Vtoggle">
    <el-collapse-transition>
      <slot v-if="status" class="box"></slot>
    </el-collapse-transition>

    <div class="searchBtn">
      <el-button class="controlShow" @click="toggleStatus" :class="{screenClose: !status}">
        <div v-if="status === false">
          展开筛选
          <i class="el-icon-caret-bottom"></i>
        </div>
        <div v-else>
          收起筛选
          <i class="el-icon-caret-top"></i>
        </div>
      </el-button>
    </div>
    <div class="smallBox" v-if="status">
      <el-button
        v-for="(item, index) in formConfig.handleConfig"
        :key="index"
        :type="item.type"
        :icon="item.icon"
        :size="item.size"
        @click="item.handleClick"
      >{{item.name}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Vtoggle',
  model: {
    prop: 'status',
    event: 'change',
  },
  props: {
    formConfig: {
      type: Object,
      default: () => {},
    },
    status: {
      type: Boolean,
      default: true, // 默认展开状态
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    toggleStatus() {
      this.$emit('change', !this.status);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/element/element-variables.scss';
@import '@/assets/scss/_animate.scss';
@import '@/assets/scss/_mixin.scss';
.Vtoggle {
  position: relative;
  background: #f5f6f7;
  margin-bottom: 20px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 20px;
  .smallBox {
    position: absolute;
    right: 20px;
    bottom: 20px;
    button {
      padding: 8px 16px !important;
      border-radius: 4px;
    }
  }
}
.searchBtn {
  text-align: center;
  .el-button:active,
  .el-button:hover {
    border: $--color-primary;
  }
  .controlShow {
    margin: auto;
    display: inline-block;
    width: 126px;
    height: 36px;
    border: none;
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    background: none;
    &:hover {
      background: rgba($color: $--color-primary, $alpha: 0.1);
      border-radius: 4px;
      color: $--color-primary;
    }
  }
}
/deep/.el-form-item {
  margin-bottom: 10px;
}
/deep/.el-form-item__error{
  top: 38px;
}
/deep/.el-input--small .el-icon-circle-close {
  line-height: 40px;
}
</style>
